/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KPIAllOfValues
 */
export interface KPIAllOfValues {
    /**
     * Time period for the KPI value (e.g., "2024-01", "Q1 2024", "2024")
     * @type {string}
     * @memberof KPIAllOfValues
     */
    period: string;
    /**
     * The KPI value for the period
     * @type {number}
     * @memberof KPIAllOfValues
     */
    value: number;
}

/**
 * Check if a given object implements the KPIAllOfValues interface.
 */
export function instanceOfKPIAllOfValues(value: object): value is KPIAllOfValues {
    if (!('period' in value) || value['period'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function KPIAllOfValuesFromJSON(json: any): KPIAllOfValues {
    return KPIAllOfValuesFromJSONTyped(json, false);
}

export function KPIAllOfValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): KPIAllOfValues {
    if (json == null) {
        return json;
    }
    return {
        
        'period': json['period'],
        'value': json['value'],
    };
}

export function KPIAllOfValuesToJSON(json: any): KPIAllOfValues {
    return KPIAllOfValuesToJSONTyped(json, false);
}

export function KPIAllOfValuesToJSONTyped(value?: KPIAllOfValues | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'period': value['period'],
        'value': value['value'],
    };
}

